const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5002/";

// Get ClickUp integration status
export const getClickUpStatus = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}v1/clickup/status`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching ClickUp status:", error);
    return { success: false, message: "Failed to fetch ClickUp status" };
  }
};

// Get ClickUp teams
export const getClickUpTeams = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}v1/clickup/teams`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching ClickUp teams:", error);
    return { success: false, message: "Failed to fetch ClickUp teams" };
  }
};

// Get ClickUp spaces for a team
export const getClickUpSpaces = async (teamId) => {
  try {
    const response = await fetch(`${API_BASE_URL}v1/clickup/spaces?teamId=${teamId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching ClickUp spaces:", error);
    return { success: false, message: "Failed to fetch ClickUp spaces" };
  }
};

// Get ClickUp lists for a space
export const getClickUpLists = async (spaceId) => {
  try {
    const response = await fetch(`${API_BASE_URL}v1/clickup/lists?spaceId=${spaceId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching ClickUp lists:", error);
    return { success: false, message: "Failed to fetch ClickUp lists" };
  }
};

// Get ClickUp team members
export const getClickUpTeamMembers = async (teamId) => {
  try {
    const response = await fetch(`${API_BASE_URL}v1/clickup/members?teamId=${teamId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching ClickUp team members:", error);
    return { success: false, message: "Failed to fetch ClickUp team members" };
  }
};

export default {
  getClickUpStatus,
  getClickUpTeams,
  getClickUpSpaces,
  getClickUpLists,
  getClickUpTeamMembers,
};